import React, {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import Box from '@mui/material/Box';
import {Layout, PageHeader, TabsContainer} from '../components';
import {
  getCustomerCards,
  getCustomerDetails,
  getCustomerGarages,
  getNotes,
  getPaymentsByCustomer,
  openModal,
  reactivateCards,
} from '../actions';
import CustomerModal from '../components/Modals/CustomerModal';
import CustomerDetailsTab from '../components/CustomerDetailsTab';
import OtherAccessTab from '../components/OtherAccessTab';
import CustomersCheckinsPage from './CustomersCheckinsPage';
import { getCheckinsByCustomer } from '../actions/reportsActions';

const HEADERS = ['Details', 'Profile', 'Add other access' , 'Check Ins'];

const CustomerDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {customerById, customersLoading} = useSelector(s => s.customers);

  const ProfileTab = (
    <Box display="flex" flexDirection="column" alignItems="center">
      <CustomerModal customer={customerById} />
    </Box>
  );

  const CheckIn = <CustomersCheckinsPage customerId={params.id}/>;
  const AddOtherAccess = <OtherAccessTab />;
  const CardsTable = <CustomerDetailsTab />;

  const TAB_CONTENTS = [CardsTable, ProfileTab, AddOtherAccess, CheckIn ];

  const title = `${customerById?.buildingName} -> ${customerById?.entranceName} -> ${customerById?.firstName} ${customerById?.lastName} (Banesa Nr: ${customerById?.flatNumber})`;

  const onBack = () => {
    navigate(-1);
  };

  const onDelete = () => {
    dispatch(openModal('DeleteModal', {item: customerById, type: 'customer'}));
  };

  const onReactivate = () => {
    dispatch(reactivateCards(params.id));
  };

  useEffect(() => {
    dispatch(getCustomerDetails(params.id));
    dispatch(getCustomerCards(params.id));
    dispatch(getPaymentsByCustomer(params.id));
    dispatch(getNotes(params.id));
    dispatch(getCustomerGarages(params.id));
    dispatch(getCheckinsByCustomer(params.id));
  }, []);

  return (
    <Layout>
      <PageHeader
        onBack={onBack}
        onDelete={!!customerById && onDelete}
        title={title}
        onReactivate={onReactivate}
        reactivateDisabled={
          !customerById ||
          customerById.reactivated ||
          customerById.status !== 'EXPIRED'
        }
        reactivateLoading={customersLoading}
      />
      <TabsContainer tabHeaders={HEADERS} tabContents={TAB_CONTENTS} />
    </Layout>
  );
};

export default CustomerDetails;
